import React from 'react';
import './Reviews.css';

const Reviews = () => {
  return (
    <div className="crumbl-reviews">
      <div className="top-section">
        <h1>Top Reviews</h1>
        <p className="subtext">Based on the highest number of upvotes</p>

        <div className="reviews">
          <div className="review">
            <div className="quote-icon">“</div>
            <p className="quote-text">Bring it back! Make this the weekly chocolate chip cookie</p>
            <p className="author">— Kailey L.</p>
          </div>

          <div className="review">
            <div className="quote-icon">“</div>
            <p className="quote-text">LOVE LOVE LOVE! Glad they didn’t do chips, the chunks add such a nice flavor. Better than original chocolate chip any day of the week.</p>
            <p className="author">— Cole G.</p>
          </div>

          <div className="review">
            <div className="quote-icon">“</div>
            <p className="quote-text">Amazing. These should be on the menu every week!</p>
            <p className="author">— Geoffrey R.</p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Reviews;
